/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ProcessLanguageLevelDto = {
    Unknown: 'UNKNOWN',
    Basic: 'BASIC',
    Intermediate: 'INTERMEDIATE',
    Advanced: 'ADVANCED',
    Proficient: 'PROFICIENT',
    Native: 'NATIVE',
} as const;

export type ProcessLanguageLevelDto = typeof ProcessLanguageLevelDto[keyof typeof ProcessLanguageLevelDto];



